export default "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/FlyerVideo-7263e77f79080df73eaf1a7bb4b0f773.mp4";